import { render, staticRenderFns } from "./Kardex.vue?vue&type=template&id=797669b6&scoped=true"
import script from "./Kardex.vue?vue&type=script&lang=js"
export * from "./Kardex.vue?vue&type=script&lang=js"
import style0 from "./Kardex.vue?vue&type=style&index=0&id=797669b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797669b6",
  null
  
)

export default component.exports